import { decimalFormat } from "../../../../../../utils";

function numberValue(value, precision = 4) {
  const parsedValue = decimalFormat(value || 0, precision);
  return isNaN(parsedValue) ? 0 : parsedValue;
}

export function calculateNFeTotals(nfe) {
  const items = nfe.items || [];
  const totalItems = items.reduce((total, item) => {
    const quantity = numberValue(item.quantity, 6);
    const salePrice = numberValue(item.item_sale_price, 4);
    return total + (quantity * salePrice);
  }, 0);

  let totalNFe = totalItems;
  items.forEach((item) => {
    totalNFe += numberValue(item.ipi && item.ipi.v_ipi);
    totalNFe += numberValue(item.icms && item.icms.v_icms_st);
  });

  const freightMode = nfe.transport && nfe.transport.mod_frete;
  if (String(freightMode) !== "9") {
    totalNFe += numberValue(nfe.shipping_value);
  }
  totalNFe += numberValue(nfe.other_expenses);

  return {
    total_items: decimalFormat(totalItems),
    total_nfe: parseFloat(totalNFe.toFixed(4)),
  };
}



// WEBPACK FOOTER //
// ./src/views/Fiscal/NFe/List/Actions/DuplicateNFe/totals.js